export default __webpack_public_path__ + "static/media/sandra.d4f63e45.png";